export function makeFigureId(id: string) {
  return `figure-${id}`;
}
